import { Content, Horizontal, StretchSpacer, Vertical } from "gls/lib";
import React from "react";
import { useTranslation } from "react-i18next";
import { style, stylesheet } from "typestyle";
import { Colours, fontFamily, Sizes } from "../../styles";
import { Form } from "../Form/Form";
import { FormTextInput } from "../Form/FormTextInput";
import { FormState } from "../Form/types";
import { isMandatory } from "../Form/validators/isMandatoryValidator";

export interface ForgotPasswordRequestProps {
  onSubmit: (username: string) => void;
  onBackToLogin?: () => void;
}

export const ForgotPasswordRequest: React.FC<ForgotPasswordRequestProps> = ({
  onSubmit,
  onBackToLogin,
}) => {
  const { t } = useTranslation();
  const onSubmitHandler = ({ username }: FormState) => {
    onSubmit(username.value);
  };

  return (
    <Vertical
      width={300}
      spacing={15}
      className={style({ fontFamily: fontFamily })}
      data-testid="login-forgot-request"
    >
      <Form
        title={t("Reset password")}
        onSubmit={onSubmitHandler}
        submitButtonText={t("Send code")}
      >
        <FormTextInput
          label={t("Username")}
          name="username"
          validators={[isMandatory]}
        />
      </Form>
      {onBackToLogin && (
        <Horizontal>
          <StretchSpacer />
          <Content
            horizontalAlign="right"
            className={classNames.backLabel}
            onClick={() => onBackToLogin?.()}
          >
            {t("Back to login")}
          </Content>
        </Horizontal>
      )}
    </Vertical>
  );
};

const classNames = stylesheet({
  backLabel: {
    color: Colours.textDark,
    cursor: "pointer",
    fontSize: Sizes.fontSize1,
    $nest: {
      "&:hover": {
        color: Colours.textLight,
      },
    },
  },
});
